import React from "react";

const Copyright = () => {
  return (
    <div className="copyright-container">
      <h6 className="copyright">
        &#169; 2018 Khoi Pham ---{" "}
        <a className="portfolio-link" href="http://www.khoipham.net">
          khoipham.net
        </a>
      </h6>
    </div>
  );
};

export default Copyright;



// WEBPACK FOOTER //
// ./src/components/homepage/Copyright.js